import { ITrigger, IAction, TriggerAction } from '../../models';

export enum TriggerActionType {
    Trigger,
    Action,
    TriggerActionLink
}

export declare type TriggerOrAction = (ITrigger | IAction | TriggerAction | null);
